import { render, staticRenderFns } from "./TransboundaryRecord.vue?vue&type=template&id=dfc8263e&scoped=true"
import script from "./TransboundaryRecord.vue?vue&type=script&lang=js"
export * from "./TransboundaryRecord.vue?vue&type=script&lang=js"
import style0 from "./TransboundaryRecord.vue?vue&type=style&index=0&id=dfc8263e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc8263e",
  null
  
)

export default component.exports